import React, {Fragment} from 'react';
import {Platform, Text, View} from 'react-native';
import DayButton from 'components/atoms/dayButton';
import {useTheme} from 'contexts/ThemeContext';
import {TDay} from 'stores/CreateClassStore';
import strings from '../../../translations';
import styleSheet from './styles';
import {useCreateClassStore} from 'contexts/StoreContext';
import {createArrayOfTime} from 'helpers/createArrayOfTime';

export interface DaysBarProps {
  data: TDay[];
  selectedDays: TDay[];
  setSelectedDays(value: TDay[]): void;
  dayButtonStyle?: object;
  onPress(value: string): void;
  onDayChanged(value: string): void;
}

const DaysBar = (props: DaysBarProps) => {
  const theme = useTheme();
  const styles = styleSheet(theme);

  const createClassStore = useCreateClassStore();
  const arrOfTime = createArrayOfTime();

  const handleOnPress = (item: TDay) => {
    props.onPress(item.day);
    props.setSelectedDays([...props.selectedDays, item]);
    props.onDayChanged(item.day);
    Platform.OS === 'web' &&
      createClassStore.setUpArrayOfTimes(item.day, arrOfTime[0]);
  };

  const getSelected = (value: string) => {
    let selected = false;

    props.selectedDays.forEach(item => {
      if (item && item.day === value) {
        selected = true;
      }
    });

    return selected;
  };

  const daysBar = (
    <View style={styles.daysBarContainerStyle}>
      {props.data.map((item, index: number) => (
        <Fragment key={index}>
          <DayButton
            key={item.day}
            abbreviation={item.abbreviation}
            dayButtonStyle={props.dayButtonStyle}
            onPress={() => handleOnPress(item)}
            selected={getSelected(item.day)}
            disabled={getSelected(item.day)}
          />
        </Fragment>
      ))}
    </View>
  );

  return (
    <View style={styles.containerStyle}>
      <Text style={styles.titleContainerStyle}>
        {strings.createClassScreen.days}
      </Text>

      {daysBar}
    </View>
  );
};

export default DaysBar;
